import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import { addUserSpecificParams } from "../../services/utils";

const IFRAME_REF = "typeform-iframe";

class TypeformLink extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  show = e => {
    e.preventDefault();

    this.setState({
      show: true
    });
  };

  hide = () => {
    this.setState({ show: false });
  };

  entered = () => {
    ReactDOM.findDOMNode(this.refs[IFRAME_REF]).focus();
  };

  render() {
    const { title, url, className } = this.props;
    const { show } = this.state;

    return (
      <span>
        <a href="/#" className={className} onClick={this.show}>
          {title}
        </a>
        {url && (
          <Modal
            backdrop
            dialogClassName="typeform-modal"
            show={show}
            onEntered={this.entered}
            onHide={this.hide}
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <iframe
                ref={IFRAME_REF}
                src={addUserSpecificParams(url)}
                style={{ width: "100%", height: "500px" }}
                title="Typeform"
              />
            </Modal.Body>
          </Modal>
        )}
      </span>
    );
  }
}

export default TypeformLink;



// WEBPACK FOOTER //
// ./src/components/typeform/link.js